import { Tables } from '@/types/database.types';
import { CustomQueryOptions } from '@/types/query';
import { useQuery } from '@tanstack/react-query';
import { getLLMApiKeys } from '../llm/api-key';
import { getQuotaLimit } from '.';
import { QuotaLimit, QuotaLimitResponse } from './type';

const keyname = 'quota-limit';
export const useGetQuotaLimitAPIKey = (
  // option?: CustomQueryOptions<Tables<'service_quota'>>
  option?: CustomQueryOptions<{
    usage: number;
    result: Tables<'llm_api_key'>[];
  }>
) => {
  return useQuery({
    queryKey: [keyname, 'api-key'],
    queryFn: async () => {
      const data = await getLLMApiKeys();
      const length = data?.length || 0;
      return {
        usage: length,
        result: data,
      };
    },
    ...option,
  });
};

export const useGetQuotaLimit = (option?: CustomQueryOptions<QuotaLimit>) => {
  return useQuery({
    queryKey: [`${keyname}`],
    queryFn: async () => {
      const data = await getQuotaLimit();
      return {
        llm_api_key: {
          max: data.quota.llm_api_quota,
          using: data.quota.llm_api_usage,
        },
        on_click_deploy: {
          max: data.quota.one_click_quota,
          using: data.quota.one_click_usage,
        },
        serverless_gpu: {
          project: {
            max: data.quota.serverless_gpu_project_quota,
            using: data.quota.serverless_gpu_project_usage,
          },
        },
      };
    },
    staleTime: 1000 * 60,
    ...option,
  });
};
